<template>
    <Modal v-model="visible" width="800px" title="上传合同影像" :footer-hide="true" :mask-closable="false" class="my-modal top" @on-cancel="$units.cancelhttpRequest()">
        <Form ref="form" :model="formData" :label-width="100" class="page-form less formGauge">
            <FormItem
                prop="documentUrls"
                label="具体文件"
                class="full"
                :rules="$units.formRule.required('请上传合同文件', 'change', 'array')"
            >
                <Upload
                    accept=".pdf"
                    fileType="pdf"
                    :multiple="true"
                    :showFileName="true" 
                    :maxFileSize="1024 * 50"
                    :limit="50"
                    @change="changeUpload"
                    ref="upload"
                ></Upload>
            </FormItem>

            <p class="text2">
                最多上传50个合同影像件，每个不超过50M，仅支持PDF文件，上传时合同影像件请以"<span class="strong">合同编码_合同名称</span>"
                命名。
            </p>
        </Form>
        <div class="ivu-modal-footer">
            <Button type="text" @click="visible = false;$units.cancelhttpRequest();">取消</Button>
            <Button type="primary" @click="submit" :loading="loading">提交</Button>
        </div>
    </Modal>
</template>
<script>


import _ from 'lodash';
import Upload from '@/components/commons/Upload/index';

export default {
    components: {
        Upload
    },

    data() {
        return {
            visible: false,
            loading: false,
            formData: {
                documentUrls: []
            },
        };
    },

    methods: {
        open() {
            this.visible = true;
            this.formData.documentUrls = [];
            this.$refs.upload.clear();
        },

        // 上传成功
        changeUpload(data) {
          this.formData.documentUrls = data;
        },

        submit() {
            this.$refs.form.validate().then(isok => {
                if (!isok) {
                    return;
                }
                if (this.loading) {
                    return;
                }
                this.loading = true;
                this.$http({
                    type: 'POST',
                    url: '/buz/userContract/mateContract',
                    data: this.formData.documentUrls,
                    apiPermissionCode:'org_6_5'
                })
                    .then(res => {
                        this.visible = false;
                        this.$emit('success');
                        const successNum = res.data.successList && res.data.successList.length;
                        const errorNum = res.data.errorList && res.data.errorList.length;
                        let text = `系统已成功上传${successNum}条数据`;
                        this.$emit('success');
                        if (errorNum) {
                            text = text + `，存在${errorNum}条数据上传失败`;
                            this.downloadErrorExcel(res.data);
                            this.$notice.error(text);
                        } else {
                            this.visible = false;
                            this.$notice.success(text);
                        }
                    })
                    .finally(res => {
                        this.loading = false;
                    });
            });
        },
        // 下载上传失败文件
        downloadErrorExcel(data) {
            this.$http({
                type: 'POST',
                url: '/buz/userContract/exportErrorContract',
                data,
                forced: true,
                responseType: 'blob',
                All: true
            }).then(res => {
                this.$units.daochu(res);
            });
        }
    }
};
</script>
<style lang="scss" scoped>
.text2 {
    margin-bottom: 10px;
    .strong {
        color: red;
        font-weight: bold;
    }
}

input {
    width: 120px;
    height: 120px;
    border: 1px dashed #dcdee2;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: 1s all;
}

input:hover {
    border: 1px dashed #3399ff;
}

input[type='file'] {
    color: transparent;
}

input #file-upload-button {
    color: red;
}

input.input-file::file-selector-button {
    display: none;
}

.a-upload {
    position: relative;
    height: 120px;

    .icon-add {
        color: #3399ff;
        position: absolute;
        top: 50%;
        margin-top: -26px;
        left: 50%;
        margin-left: -26px;
        z-index: -1;
    }
}

.wrapper {
    display: flex;
    flex-wrap: wrap;
    .demo-upload-list {
        display: inline-block;
        width: 120px;
        height: 120px;
        text-align: center;
        line-height: 120px;
        border: 1px solid transparent;
        border-radius: 4px;
        overflow: hidden;
        background: #fff;
        position: relative;
        margin-right: 4px;
        margin-bottom: 4px;
    }

    .demo-upload-list:hover .file-name {
        display: none;
    }

    .demo-upload-list img {
        width: 100%;
        height: 100%;
    }

    .demo-upload-list-img {
        width: 100%;
        max-width: 280px;
        height: 173px;
        background-color: #f5f7f9;
        box-shadow: none;
        img {
            width: auto !important;
            max-width: 100%;
            object-fit: cover;
        }
    }

    .demo-upload-list-cover {
        display: none;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: rgba(0, 0, 0, 0.6);

        align-items: center;
        justify-content: center;
    }

    .file-name {
        position: absolute;
        bottom: 0;
        background: rgba(0, 0, 0, 0.5);
        line-height: 15px;
        width: 100%;
        padding: 2px 5px;
        text-align: left;
        color: #fff;
        font-size: 12px;
        word-break: break-all;
        overflow: hidden;
        text-overflow: ellipsis; /* 超出部分省略号 */
        display: -webkit-box; /* 对象作为伸缩盒子模型显示 */
        -webkit-box-orient: vertical; /* 设置或检索伸缩盒对象的子元素的排列方式 */
        -webkit-line-clamp: 2; /* 显示的行数 */
        max-height: 30px; /* 设置最大高度，根据行高，要几行乘以几倍 */
    }

    .demo-upload-list:hover .demo-upload-list-cover {
        display: flex;
    }

    .demo-upload-list-cover {
        &.ont-btn {
            width: 100%;
            height: 100%;
            align-items: center;
            i {
                width: 100%;
                height: 100%;
                align-items: center;
                display: flex;
                justify-content: center;
            }
        }
        i {
            color: #fff;
            font-size: 20px;
            cursor: pointer;
            padding: 10px;
        }
    }

    .imgList {
        float: left;

        li {
            position: relative;
            float: left;
            width: 120px;
            height: 120px;
            margin: 10px;

            .close {
                position: absolute;
                width: 100%;
                height: 100%;
                left: 0;
                top: 0;
                right: 0;
                bottom: 0;
                background: rgba(0, 0, 0, 0.5);
                color: #fff;
                text-align: center;
                font-size: 16px;
                display: flex;
                justify-content: center;
                align-items: center;

                span {
                    margin-right: 10px;
                }

                &:hover {
                    cursor: pointer;

                    &:last-child {
                        margin-right: 0;
                    }
                }
            }

            img {
                &:hover {
                    cursor: pointer;
                }

                width: 100%;
                height: 100%;
            }
        }
    }
}
</style>
